import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/GlassBits";
import { formatINR, formatDate, statusBadgeClass } from "@/lib/format";
import { ExternalLink } from "lucide-react";

export default function CustomerTransactions() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => setItems((await api.get("/customer/transactions")).data))(); }, []);
  return (
    <div>
      <SectionTitle eyebrow="History" title="All transactions" />
      <div className="ldc-glass overflow-hidden">
        <div className="overflow-x-auto ldc-scroll">
          <table className="w-full ldc-table" data-testid="ctransactions-table">
            <thead>
              <tr>
                <th>Invoice</th>
                <th>Purpose</th>
                <th>Branch</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (<tr><td colSpan={8} className="text-center py-10 text-white/40">No transactions yet.</td></tr>)}
              {items.map((t) => (
                <tr key={(t.payment_id || t.invoice_no) + t.created_at}>
                  <td className="font-mono text-[#fbce18]">{t.invoice_no}</td>
                  <td>{t.purpose || "—"}</td>
                  <td>{t.branch}</td>
                  <td className="font-medium">{formatINR(t.amount)}</td>
                  <td className="uppercase text-xs">{t.method || "—"}</td>
                  <td><span className={statusBadgeClass(t.status)}>{t.status}</span></td>
                  <td className="text-xs text-white/50">{formatDate(t.created_at)}</td>
                  <td className="text-xs">
                    {t.payment_link && t.status === "pending" && (
                      <a href={t.payment_link} target="_blank" rel="noreferrer" className="text-[#fbce18] inline-flex items-center gap-1">Pay <ExternalLink size={12}/></a>
                    )}
                    <a href={`/invoice/${t.invoice_no}`} target="_blank" rel="noreferrer" className="ml-2 text-white/70">View</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
